import React from 'react';
import { PictoProps } from './index';

export const Envelope = (props: PictoProps) => (
  <svg
    width={props.width || '23'}
    height={props.height || '18'}
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.896 1H19.896C20.996 1 21.896 1.9 21.896 3V15C21.896 16.1 20.996 17 19.896 17H3.896C2.796 17 1.896 16.1 1.896 15V3C1.896 1.9 2.796 1 3.896 1Z"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.896 3L11.896 10L1.896 3"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
